// extracted by mini-css-extract-plugin
export default {"monthAndYear":"MonthAndYear_monthAndYear__ltg6l"};